import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { EntityTypes } from 'context/entityContext';
import { ChartTypes } from 'types/shared';

import { TopicFilterNames } from 'components/TopicFilters/shared';

interface IChartsKPIURLArgs {
  countryIds?: string | string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityIds: string[];
  entityType: EntityTypes;
  chartType?: ChartTypes;
}

export default function getChartsKPIURL(args: IChartsKPIURLArgs): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityIds,
    entityType,
    chartType,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds,
    customerFilter,
    download,
    chartType,
  });

  return `/api/charts/kpi/${type}/${entityIds}?${params}`;
}
